(function () {
  'use strict';

  /* ─── Guard: évite double-définition en SPA Shopify ─── */
  if (customElements.get('ube-carousel')) return;

  /* ─── Polyfill minimal requestAnimationFrame ─── */
  var raf = window.requestAnimationFrame
         || window.webkitRequestAnimationFrame
         || window.mozRequestAnimationFrame
         || function (cb) { return setTimeout(cb, 16); };

  /* ═══════════════════════════════════════════════
     CLASS UbeCarousel
     Compatible ES5 + Custom Elements V1
  ═══════════════════════════════════════════════ */
  function UbeCarousel() {
    return Reflect.construct(HTMLElement, [], UbeCarousel);
  }
  UbeCarousel.prototype = Object.create(HTMLElement.prototype);
  UbeCarousel.prototype.constructor = UbeCarousel;

  UbeCarousel.prototype.connectedCallback = function () {
    var self      = this;
    self.curr     = 0;
    self.total    = parseInt(self.dataset.count, 10) || 3;
    self.cards    = Array.prototype.slice.call(self.querySelectorAll('.ube-card'));
    self.dots     = [];
    self.prevBtn  = self.querySelector('.ube-prev');
    self.nextBtn  = self.querySelector('.ube-next');
    self.stage    = self.querySelector('.ube-stage');
    self._busy    = false; /* verrou anti-spam clic */

    /* Boutons fléchés */
    self.prevBtn.addEventListener('click', function () { self.move(-1); });
    self.nextBtn.addEventListener('click', function () { self.move(1);  });

    /* Dots */
    self.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.dataset.goto, 10);
        if (target !== self.curr) self.goTo(target);
      });
    });

    /* Clic sur carte latérale */
    self.cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('is-next')) self.move(1);
        if (card.classList.contains('is-prev')) self.move(-1);
      });

      /* Keyboard navigation */
      card.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') self.move(1);
        if (e.key === 'ArrowLeft')  self.move(-1);
      });

      /* Play event → fade out poster */
      var vid = card.querySelector('video');
      if (vid) {
        vid.addEventListener('play', function () {
          card.querySelector('.ube-media-box').classList.add('video-playing');
        });
        vid.addEventListener('pause', function () {
          card.querySelector('.ube-media-box').classList.remove('video-playing');
        });
      }
    });

    /* ─── Swipe tactile avec RAF pour fluidité Android ─── */
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeLocked = false;

    self.stage.addEventListener('touchstart', function (e) {
      swipeStartX = e.changedTouches[0].screenX;
      swipeStartY = e.changedTouches[0].screenY;
      swipeLocked = false;
    }, { passive: true });

    self.stage.addEventListener('touchmove', function (e) {
      /* Verrouille l'axe dominant pour éviter les faux swipes verticaux */
      if (swipeLocked) return;
      var dx = Math.abs(e.changedTouches[0].screenX - swipeStartX);
      var dy = Math.abs(e.changedTouches[0].screenY - swipeStartY);
      if (dy > dx) swipeLocked = true;
    }, { passive: true });

    self.stage.addEventListener('touchend', function (e) {
      if (swipeLocked) return;
      var endX = e.changedTouches[0].screenX;
      var diff = endX - swipeStartX;
      raf(function () {
        if (diff < -50) self.move(1);
        if (diff >  50) self.move(-1);
      });
    }, { passive: true });

    /* Init */
    self.updateClasses();
    self.updateVideo();
  };

  /* ─── move: direction relative ─── */
  UbeCarousel.prototype.move = function (dir) {
    if (this._busy) return;
    this.goTo((this.curr + dir + this.total) % this.total);
  };

  /* ─── goTo: index absolu ─── */
  UbeCarousel.prototype.goTo = function (index) {
    if (this._busy || index === this.curr) return;
    var self  = this;
    self._busy = true;
    /* Promotion GPU temporaire — uniquement pendant la transition */
    self.cards.forEach(function(c) { c.style.willChange = 'transform, opacity'; });
    self.curr  = index;
    self.updateClasses();
    self.updateDots();
    self.updateVideo();
    /* Déverrouille et libère les layers GPU après transition CSS (500ms) */
    setTimeout(function () {
      self._busy = false;
      self.cards.forEach(function(c) { c.style.willChange = 'auto'; });
    }, 520);
  };

  /* ─── updateClasses: positionne chaque carte ─── */
  UbeCarousel.prototype.updateClasses = function () {
    var self  = this;
    var total = self.total;
    var curr  = self.curr;
    var prev  = (curr - 1 + total) % total;
    var next  = (curr + 1) % total;

    self.cards.forEach(function (card, i) {
      card.classList.remove('is-active', 'is-prev', 'is-next');
      card.setAttribute('aria-hidden', 'true');
      card.setAttribute('tabindex', '-1');

      if (i === curr) {
        card.classList.add('is-active');
        card.removeAttribute('aria-hidden');
        card.setAttribute('tabindex', '0');
      } else if (i === next) {
        card.classList.add('is-next');
      } else if (i === prev) {
        card.classList.add('is-prev');
      }
      /* Les cartes restantes (>3 slides) restent cachées (opacity: 0 par défaut) */
    });
  };

  /* ─── updateDots ─── */
  UbeCarousel.prototype.updateDots = function () {
    var curr = this.curr;
    this.dots.forEach(function (dot, i) {
      var active = (i === curr);
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  };

  /* ─── updateVideo: gestion propre sans appel .load() ─── */
  UbeCarousel.prototype.updateVideo = function () {
    var self = this;
    var curr = self.curr;

    self.cards.forEach(function (card, i) {
      var vid  = card.querySelector('video');
      var mbox = card.querySelector('.ube-media-box');
      if (!vid) return;

      if (i !== curr) {
        /* ── Inactif: pause + libère source sans .load() (évite pic CPU) ── */
        vid.pause();
        if (vid.hasAttribute('src')) {
          vid.removeAttribute('src');
        }
        /* Remet le poster */
        if (mbox) mbox.classList.remove('video-playing');

      } else {
        /* ── Actif: charge et joue ── */
        var dataSrc = vid.dataset.src;
        if (dataSrc) {
          var currentSrc = vid.getAttribute('src');
          if (!currentSrc || currentSrc !== dataSrc) {
            vid.src = dataSrc;
            vid.preload = 'auto';
          }
          vid.play().catch(function () {
            /* Autoplay bloqué (politique navigateur) → poster reste visible, pas d'erreur console */
          });
        }
      }
    });
  };

  /* ─── Définition du Custom Element ─── */
  try {
    customElements.define('ube-carousel', UbeCarousel);
  } catch (e) {
    /* Silencieux si déjà défini (hot-reload Shopify Theme Editor) */
  }

}());
